import { Link } from "react-router-dom";
import { MaskedLines, FadeUp, Eyebrow } from "@/components/Reveal";

export default function PageHeader({ eyebrow, titleLines, answer, crumbs = [] }) {
    return (
        <section className="bg-chalk px-6 md:px-12 lg:px-16 pt-36 md:pt-44 pb-16 md:pb-24" data-testid="page-header">
            {crumbs.length > 0 && (
                <nav aria-label="Breadcrumb" className="mb-10" data-testid="breadcrumbs">
                    <ol className="flex flex-wrap items-center gap-2 font-sans text-[10px] tracking-[0.2em] uppercase text-slate">
                        <li><Link to="/" className="hover:text-graphite transition-colors" data-testid="breadcrumb-home">Home</Link></li>
                        {crumbs.map((c, i) => (
                            <li key={i} className="flex items-center gap-2">
                                <span aria-hidden="true" className="text-gold">/</span>
                                {c.path ? (
                                    <Link to={c.path} className="hover:text-graphite transition-colors" data-testid={`breadcrumb-${i}`}>{c.name}</Link>
                                ) : (
                                    <span className="text-graphite" data-testid={`breadcrumb-${i}`}>{c.name}</span>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>
            )}
            {eyebrow && <Eyebrow className="mb-8">{eyebrow}</Eyebrow>}
            <MaskedLines
                lines={titleLines}
                as="h1"
                className="font-serif font-light text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight text-graphite max-w-5xl"
                lineClassName=""
            />
            {answer && (
                <FadeUp delay={0.5} className="mt-12 max-w-2xl border-l-2 border-gold pl-6">
                    <p className="font-sans text-base md:text-lg leading-relaxed text-graphite/80" data-testid="answer-block">
                        {answer}
                    </p>
                </FadeUp>
            )}
        </section>
    );
}
